import React from "react";
import styles from "./EmptySearchState.module.css";

export type EmptySearchStateProps = {
  onClearSearch: () => void;
  title?: string;
  subtitle?: string;
  clearLabel?: string;
  className?: string;
};

export function EmptySearchState({
  onClearSearch,
  title = "No matching results",
  subtitle = "We couldn\u2019t find what you are looking for. Try different criteria.",
  clearLabel = "Clear search",
  className,
}: EmptySearchStateProps) {
  return (
    <div
      className={[styles.wrapper, className].filter(Boolean).join(" ")}
    >
      <div className={styles.root} role="status">
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.subtitle}>{subtitle}</p>
        <button
          type="button"
          className={styles.clearBtn}
          onClick={onClearSearch}
        >
          {clearLabel}
        </button>
      </div>
    </div>
  );
}
